module.exports = __webpack_public_path__ + "img/github-logo.8e171eb1.png";